<template>
  <div class="price" :class="{ 'price--onsale': isOnSale }">
    <span class="price__original">{{ formattedOriginalPrice }}</span>
    <span v-if="isOnSale" class="price__sale">
      {{ formattedPrice }}
      <span v-if="showPercent">({{ percentageDiscount }}% off)</span>
    </span>
    <span v-if="showSalePreview" class="price__sale">
      {{ salePreviewPrice }}
    </span>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ProductPrice",
  props: {
    showFinalSaleText: {
      type: Boolean,
      default: false,
    },
    showPercent: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters("product", [
      "isOnSale",
      "originalPrice",
      "price",
      "variant",
      "salePreviewPrice",
    ]),
    ...mapGetters("auth", ["isLoggedIn"]),
    showSalePreview() {
      return this.isLoggedIn && this.salePreviewPrice;
    },
    formattedPrice() {
      return this.$filters.toCurrency(
        this.price.amount,
        this.price.currencyCode,
        0
      );
    },
    formattedOriginalPrice() {
      if (this.isOnSale) {
        return this.$filters.toCurrency(
          this.originalPrice.amount,
          this.originalPrice.currencyCode,
          0
        );
      }

      return this.formattedPrice;
    },
    percentageDiscount() {
      return Math.round(
        ((this.originalPrice.amount - this.price.amount) /
          this.originalPrice.amount) *
          100
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.price {
  @include utility-label(16px);

  &--onsale {
    .price__original {
      text-decoration: line-through;
    }
  }

  &__original {
    margin-right: 8px;
  }

  &__sale {
    color: $color-red;
  }

  &__final-sale {
    @include utility-label(15px);
    color: $color-grey-dark;
    position: absolute;
  }
}
</style>
